<template>
  <AuthLoginElement>
    <slot />
  </AuthLoginElement>
</template>
